<template>
    <!-- <div @click="$router.push(`/produktkategorien/${data.slug.name}`)" -->
    <div class="rounded-xl shadow-md hover:shadow-xl w-full h-[232px] justify-between card relative text-white">
        <div class="flex flex-col h-full">
            <div class="basis-[33%] flex px-4 bg-bluei">
                <div class="w-3/4 bg-redi my-auto">
                    <h3 class="w-full text-base font-semibold">
                        {{ $translate(data.name) }}
                    </h3>

                    <!-- Neu-Tag -->
                    <img
                        v-if="showNeuTag && data.slug?.name == 'aktien'"
                        class="absolute left-1 top-1 w-12"
                        :src="$asset('/hkcm/images/neu.png', 'public')"
                        alt="HKCM Logo"
                        title="HKCM Logo"
                    />
                </div>
                <div class="w-1/4 px-2 bg-yellow-500i my-auto">
                    <img :alt="$translate(data.name)" :src="data.image.replace('.png', '-white.png')" class="w-auto h-auto" />
                </div>
            </div>
            <div class="grow px-4 bg-orange-500i">
                <p class="line-clamp-7 text-xs">
                    {{ $translate(data.short_description) }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: Object
    },
    data: () => ({
        showNeuTag: false
    }),
    computed: {
        background() {
            return 'linear-gradient(to bottom, ' + this.data.background_color + ' 0%, ' + this.data.background_gradient + ' 100%)';
        }
    }
};
</script>

<style scoped>
.card {
    background: v-bind(background);
}
</style>
